<om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
<div class="flex">
  <div>
    <svg-icon *ngIf="control.value" class="icon-preview" [size]="32" [name]="control.value"></svg-icon>
  </div>
  <nz-select class="w-full" [nzDisabled]="disabled" [formControl]="control" [nzMode]="mode" [nzAllowClear]="clear">
    <nz-option *ngFor="let item of options" [nzValue]="item[valueName]" [nzLabel]="item[labelName]"> </nz-option>
  </nz-select>
</div>
<div class="om-error-placeholder">
  <om-error [control]="control"></om-error>
</div>
